export const ALLOWED_CORS_ORIGINS = [
  'http://localhost:4200', 
  'http://localhost:4201', 
  'https://staging.example.com',
  'https://aca.crm.perlasindustrade.ph',
  'https://aca.crm.perlasindustrade.ph/**',
]